import { render } from "./ListDocument.vue?vue&type=template&id=1283bc9e&scoped=true&ts=true"
import script from "./ListDocument.vue?vue&type=script&lang=ts"
export * from "./ListDocument.vue?vue&type=script&lang=ts"

import "./ListDocument.vue?vue&type=style&index=0&id=1283bc9e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1283bc9e"]])

export default __exports__